import React, { useEffect, useState , Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Collapse,
} from "reactstrap";

const Services = (props) => {


  return (
      <>
      <section className="bg-half-170 bg-light d-table w-100">
          <Container className="w-50">
                <h1>Our Services</h1>
          </Container>
      </section>
      </>
  )
};

export default Services;
